import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import useToggleCart from 'global-state/isCartOpen/useToggleCart';
import useBagCount from 'hooks/useBagCount';
import useFavoriteCount from 'hooks/useFavoriteCount';
import HeaderToolbarUI from './HeaderToolbarUI';
const HeaderToolbar = t0 => {
  const $ = _c(5);
  const {
    accountTo
  } = t0;
  const toggleCart = useToggleCart();
  const bagCount = useBagCount();
  const favoriteCount = useFavoriteCount();
  let t1;
  if ($[0] !== accountTo || $[1] !== bagCount || $[2] !== favoriteCount || $[3] !== toggleCart) {
    t1 = <HeaderToolbarUI bagCount={bagCount} favoriteCount={favoriteCount} accountTo={accountTo} onBagClick={toggleCart} />;
    $[0] = accountTo;
    $[1] = bagCount;
    $[2] = favoriteCount;
    $[3] = toggleCart;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return t1;
};
HeaderToolbar.propTypes = {
  accountTo: PropTypes.string
};
export default HeaderToolbar;